export default __webpack_public_path__ + "static/media/lr pic 3.f59e927e.svg";